/**
 * AppLoader — the brand loading screen shown while lazy route chunks resolve
 * (the React `<Suspense>` fallback).
 *
 * It is visually identical to the pre-React boot loader inlined in
 * `index.html` and REUSES the same `cqb-*` styles defined once in that file's
 * `<head>` — so the hand-off from cold boot to first route is seamless and
 * there is a single source of truth for the visual. Dark brand surface (a
 * splash, independent of theme); one motion only (the coral ECG sweep); the
 * shared CSS honours `prefers-reduced-motion`.
 */
export function AppLoader() {
  return (
    <div className="cqb-root" role="status" aria-label="Loading CardioQ">
      <div className="cqb-screen">
        <div className="cqb-stack">
          <div className="cqb-markwrap">
            <span className="cqb-bloom" />
            <span className="cqb-mark">
              <svg viewBox="0 0 32 30" aria-hidden="true">
                <defs>
                  <linearGradient id="cqbGrad" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stopColor="#2a5fe0" />
                    <stop offset=".5" stopColor="#1f6fe5" />
                    <stop offset="1" stopColor="#22c3ed" />
                  </linearGradient>
                </defs>
                <path
                  d="M23.6,1.5 C20.2,1.5 17.3,4 16,6.9 C14.7,4 11.8,1.5 8.4,1.5 C3.8,1.5 0.6,5.2 0.6,9.8 c0,9.1 9.4,11.6 15.4,20.1 c6-8.5 15.4,-11 15.4,-20.1 C31.4,5.2 28.2,1.5 23.6,1.5 z"
                  fill="none"
                  stroke="url(#cqbGrad)"
                  strokeWidth="2"
                />
                <path
                  d="M4,16 H10.5 l1.8,-5.5 l2.7,11 l2.4,-8 l1.7,3.5 H28"
                  fill="none"
                  stroke="#fb5249"
                  strokeWidth="1.6"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </div>
          <div className="cqb-ecg">
            <svg viewBox="0 0 240 60" preserveAspectRatio="none" aria-hidden="true">
              <path
                className="cqb-base"
                d="M0,42 H60 l8,0 l6,-26 l8,44 l7,-30 l6,12 H150 l8,0 l6,-16 l6,16 H240"
              />
              <path
                className="cqb-run"
                d="M0,42 H60 l8,0 l6,-26 l8,44 l7,-30 l6,12 H150 l8,0 l6,-16 l6,16 H240"
              />
            </svg>
          </div>
          <div className="cqb-word">
            Cardio<b>Q</b>
            <span>.ai</span>
          </div>
        </div>
        <div className="cqb-micro">LOADING</div>
      </div>
    </div>
  );
}

export default AppLoader;
